import { render, staticRenderFns } from "./ImageLibraryModal.vue?vue&type=template&id=0bcc0c95&scoped=true"
import script from "./ImageLibraryModal.vue?vue&type=script&lang=js"
export * from "./ImageLibraryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcc0c95",
  null
  
)

export default component.exports